var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import { Login, Signup } from '../Forms';
import { PathEnum } from '../Model';
import { LoginMFA } from '../Forms/LoginMFA';
var Main = (function (_super) {
    __extends(Main, _super);
    function Main(props) {
        var _this = _super.call(this, props) || this;
        _this.pathMap = {
            LOGIN: PathEnum.LOGIN,
            SIGNUP: PathEnum.SIGNUP,
        };
        _this.state = { mfaRequired: false, mfaPendingCredential: '', mfaEnrollmentId: '', phoneNumber: '' };
        _this.onSignupCreate = _this.onSignupCreate.bind(_this);
        _this.onLoginCreate = _this.onLoginCreate.bind(_this);
        _this.onMfaRequired = _this.onMfaRequired.bind(_this);
        return _this;
    }
    Main.prototype.onMfaRequired = function (mfaRequired, mfaPendingCredential, mfaEnrollmentId, phoneNumber) {
        this.setState({ mfaRequired: mfaRequired, mfaPendingCredential: mfaPendingCredential, mfaEnrollmentId: mfaEnrollmentId, phoneNumber: phoneNumber });
    };
    Main.prototype.onSignupCreate = function () {
        var _a = this.props, source = _a.source, locale = _a.locale, simplicityUrl = _a.simplicityUrl, draft = _a.draft, settingsApiUrl = _a.settingsApiUrl, integrationConfig = _a.integrationConfig, onSignedUp = _a.onSignedUp, trackButton = _a.trackButton, draftCallback = _a.draftCallback;
        return (React.createElement(Signup, { simplicityUrl: simplicityUrl, source: source, locale: locale || 'en-US', settingsApiUrl: settingsApiUrl, draft: draft, integrationConfig: integrationConfig, onSignup: onSignedUp, trackButton: trackButton, draftCallback: draftCallback }));
    };
    Main.prototype.onLoginCreate = function () {
        var _a = this.props, source = _a.source, locale = _a.locale, forgotPasswordUrl = _a.forgotPasswordUrl, cookiesDomain = _a.cookiesDomain, createAccountUrl = _a.createAccountUrl, authenticationApiUrl = _a.authenticationApiUrl, trackPage = _a.trackPage, trackLink = _a.trackLink, trackButton = _a.trackButton, onLoggedIn = _a.onLoggedIn, firebaseOptions = _a.firebaseOptions;
        var _b = this.state, mfaRequired = _b.mfaRequired, mfaPendingCredential = _b.mfaPendingCredential, mfaEnrollmentId = _b.mfaEnrollmentId, phoneNumber = _b.phoneNumber;
        if (mfaRequired) {
            return (React.createElement(LoginMFA, { source: source, locale: locale || 'en-US', cookiesDomain: cookiesDomain, authenticationApiUrl: authenticationApiUrl, mfaPendingCredential: mfaPendingCredential, mfaEnrollmentId: mfaEnrollmentId, phoneNumber: phoneNumber, firebaseOptions: firebaseOptions, onLoggedIn: onLoggedIn, trackButton: trackButton }));
        }
        return (React.createElement(Login, { source: source, locale: locale || 'en-US', forgotPasswordUrl: forgotPasswordUrl, cookiesDomain: cookiesDomain, createAccountUrl: createAccountUrl, authenticationApiUrl: authenticationApiUrl, trackPage: trackPage, trackLink: trackLink, trackButton: trackButton, onLoggedIn: onLoggedIn, onMfaRequired: this.onMfaRequired }));
    };
    Main.prototype.render = function () {
        var path = this.props.path;
        return (React.createElement(Router, null,
            React.createElement(Route, { path: "/login", component: this.onLoginCreate }),
            React.createElement(Route, { path: "/signup", component: this.onSignupCreate }),
            React.createElement(Redirect, { to: "" + (path ? this.pathMap[path] : PathEnum.LOGIN) + window.location.search })));
    };
    return Main;
}(React.Component));
export { Main };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/ecommscript-integrationappauth/dist/Containers/Main.js
// module id = 790
// module chunks = 0